<app-navbar></app-navbar>

<div class="search-question-layout">
  <a routerLink="/dashboard" class="back-link">
    <i class="bi bi-arrow-left"></i> Back to Dashboard
  </a>

  <h1 class="page-title">Search Question</h1>
  <p class="page-subtitle">Find specific questions by course, subject, or text in question, answer, or explanation.</p>

  <!-- Search criteria panel -->
  <div class="panel search-panel">
    <label class="panel-label">Search Criteria</label>
    <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
      <div class="search-form-row">
        <div class="filter-group">
          <label for="courseId" class="filter-label">Course</label>
          <select class="form-select" id="courseId" formControlName="courseId" (change)="onCourseChange()">
            <option value="">All Courses</option>
            <option *ngFor="let course of courses" [value]="course.courseId">
              {{ course.courseTitle }}
            </option>
          </select>
          <small class="text-muted form-text" *ngIf="courses.length === 0">No courses available. Please check your database.</small>
        </div>
        <div class="filter-group">
          <label for="subjectId" class="filter-label">Subject</label>
          <select class="form-select" id="subjectId" formControlName="subjectId" [disabled]="!selectedCourseId || selectedCourseId === ''">
            <option value="">All Subjects</option>
            <option *ngFor="let subject of subjects" [value]="subject.subjectId">
              {{ subject.subjectTitle }}
            </option>
          </select>
          <small class="text-muted form-text" *ngIf="!selectedCourseId || selectedCourseId === ''">Please select a course first</small>
        </div>
      </div>
      <div class="search-form-row">
        <div class="filter-group">
          <label for="question" class="filter-label">Question</label>
          <input type="text" class="form-control" id="question" formControlName="question"
                 placeholder="Search in question text...">
        </div>
        <div class="filter-group">
          <label for="answer" class="filter-label">Answer</label>
          <input type="text" class="form-control" id="answer" formControlName="answer"
                 placeholder="Search in answer text...">
        </div>
        <div class="filter-group">
          <label for="explanation" class="filter-label">Explanation</label>
          <input type="text" class="form-control" id="explanation" formControlName="explanation"
                 placeholder="Search in explanation text...">
        </div>
      </div>
      <div class="search-form-row">
        <div class="filter-group filter-group-id">
          <label for="questionNumber" class="filter-label">Question Number</label>
          <input type="text" class="form-control" id="questionNumber" formControlName="questionNumber"
                 placeholder="Search by question ID...">
        </div>
      </div>
      <div class="search-actions">
        <button type="submit" class="btn btn-primary btn-search" [disabled]="isLoading">
          <span *ngIf="!isLoading"><i class="bi bi-search"></i> Search</span>
          <span *ngIf="isLoading">
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Searching...
          </span>
        </button>
      </div>
    </form>
  </div>

  <div *ngIf="searchError" class="alert alert-warning" role="alert">
    {{ searchError }}
  </div>

  <!-- Search Results panel -->
  <div class="panel results-panel" *ngIf="hasSearched">
    <div class="results-panel-header">
      <label class="panel-label mb-0">Search Results</label>
      <span class="results-badge">{{ searchResults.length }}</span>
    </div>
    <div class="results-panel-body">
      <app-question-results-list
        [results]="searchResults"
        [displayHtmlById]="resultDisplayHtmlById"
        [showMatchedField]="true"
        [isLoading]="isLoading"
        [selectable]="true"
        (selectQuestion)="openDetail($event)"
        emptyMessage="No results found. Try adjusting your search criteria."
      ></app-question-results-list>
    </div>
  </div>
</div>

<app-question-detail-modal
  [open]="detailOpen"
  [questionId]="detailQuestionId"
  [questionHtml]="detailQuestionHtml"
  [answersHtml]="detailAnswersHtml"
  [correctAnswer]="detailCorrectAnswer"
  (closed)="closeDetail()">
</app-question-detail-modal>
